import { ReactNode, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';

interface PortalProps {
  children: ReactNode;
  wrapperId?: string;
}

// Função auxiliar para criar o elemento wrapper se ele não existir
function createWrapperAndAppendToBody(wrapperId: string) {
  const wrapperElement = document.createElement('div');
  wrapperElement.setAttribute("id", wrapperId);
  document.body.appendChild(wrapperElement);
  return wrapperElement;
}

const Portal: React.FC<PortalProps> = ({ children, wrapperId = "portal-wrapper" }) => {
  const [wrapperElement, setWrapperElement] = useState<HTMLElement | null>(null);

  useEffect(() => {
    let element = document.getElementById(wrapperId);
    let systemCreated = false;
    
    // Se o elemento wrapper não existir, criamos e anexamos ao body
    if (!element) {
      element = createWrapperAndAppendToBody(wrapperId);
      systemCreated = true;
    }
    
    setWrapperElement(element);

    // Limpeza: remove o elemento se ele foi criado pelo sistema
    return () => {
      if (systemCreated && element?.parentNode) {
        element.parentNode.removeChild(element);
      }
    };
  }, [wrapperId]);

  // Se o wrapper ainda não foi criado (primeira renderização), retorna null
  if (wrapperElement === null) return null;

  // Renderiza o children dentro do wrapper usando o Portal
  return createPortal(children, wrapperElement);
};

export default Portal;